var $c990249689bb58d0$exports = {};
$c990249689bb58d0$exports = {
    "decrease": (args)=>`${args.fieldLabel} cs\xf6kkent\xe9se`,
    "increase": (args)=>`${args.fieldLabel} n\xf6vel\xe9se`,
    "numberField": `Sz\xe1mmez\u{151}`
};


export {$c990249689bb58d0$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
